(() => {
  function reportInitError(scope, err) {
    try {
      document.dispatchEvent(new CustomEvent("pma:observability", {
        detail: { kind: "error", error_type: "commerce_" + scope, message: (err && err.message) || String(err) },
        bubbles: true
      }));
    } catch (e) { /* ignore dispatch failure */ void e; }
  }
  try {
  const qsa = (selector, root = document) =>
    Array.from(root.querySelectorAll(selector));

  function hasCommerceSurface() {
    const body = document.body;
    if (!body) return false;
    if (
      body.classList.contains("template-index")
      || body.classList.contains("template-collection")
      || body.classList.contains("template-product")
      || body.classList.contains("template-cart")
      || body.classList.contains("template-page-shop")
    ) {
      return true;
    }
    return Boolean(
      document.querySelector(
        '[data-section-handle^="pma__commerce__"], [data-qty-control], [data-variant-select], [data-pma-filters-form], [data-pma-cart-form], .pma-buybox, [data-product-sticky-atc]'
      )
    );
  }

  if (!hasCommerceSurface()) {
    // Still normalize locked price-sort URLs on any storefront page (APA-UX-018).
    try {
      const locked = document.body?.classList?.contains("is-member-locked");
      if (locked) {
        const u = new URL(window.location.href);
        const sb = String(u.searchParams.get("sort_by") || "");
        if (/^price-(ascending|descending)$/.test(sb)) {
          const safe = window.location.pathname.indexOf("/search") === 0 ? "relevance" : "manual";
          u.searchParams.set("sort_by", safe);
          u.searchParams.delete("page");
          window.location.replace(u.pathname + u.search + u.hash);
        }
      }
    } catch {}
    return;
  }

  // APA-UX-018: locked visitors must not remain on price-ordered URLs.
  try {
    const locked = document.body?.classList?.contains("is-member-locked");
    if (locked) {
      const u = new URL(window.location.href);
      const sb = String(u.searchParams.get("sort_by") || "");
      if (/^price-(ascending|descending)$/.test(sb)) {
        const select = document.querySelector(
          "select[data-pma-collection-sort], form[data-pma-search-sort] select[name='sort_by']",
        );
        const canonicalCatalogSearch =
          String(window.location.pathname || "").replace(/\/+$/, "") === "/collections/all" &&
          String(u.searchParams.get("q") || "").trim() !== "";
        const safe =
          canonicalCatalogSearch
            ? "relevance"
            : (select && select.querySelector("option[selected]")?.value) ||
              (select && select.options?.[0]?.value) ||
              (window.location.pathname.indexOf("/search") === 0 ? "relevance" : "manual");
        u.searchParams.set("sort_by", safe);
        u.searchParams.delete("page");
        window.location.replace(u.pathname + u.search + u.hash);
        return;
      }
    }
  } catch {}

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  const setupQuantityControl = (wrapper) => {
    const input = wrapper.querySelector("[data-qty-input]");
    const dec = wrapper.querySelector("[data-qty-decrement]");
    const inc = wrapper.querySelector("[data-qty-increment]");
    if (!input) return;

    const min = Number(input.getAttribute("min") || "1");
    const max = Number(input.getAttribute("max") || "9999");

    const update = (delta) => {
      const current = Number(input.value || min);
      const next = clamp(current + delta, min, max);
      if (next === current) return;
      input.value = String(next);
      input.dispatchEvent(new Event("change", { bubbles: true }));
      const status = wrapper.querySelector("[data-qty-status]");
      if (status) {
        const rawLabel = input.getAttribute("aria-label") || wrapper.getAttribute("aria-label");
        const prefix = rawLabel ? rawLabel.replace(/:\s*$/, "") : "Quantity";
        status.textContent = prefix + ": " + next;
      }
    };

    dec?.addEventListener("click", (event) => {
      event.preventDefault();
      update(-1);
    });

    inc?.addEventListener("click", (event) => {
      event.preventDefault();
      update(1);
    });
  };

  const setupVariantSelect = (select) => {
    const targetId = select.getAttribute("data-variant-target");
    const target = targetId ? document.getElementById(targetId) : null;
    if (!target) return;
    select.addEventListener("change", () => {
      target.value = select.value;
      target.dispatchEvent(new Event("change", { bubbles: true }));
    });
  };

  qsa("[data-qty-control]").forEach(setupQuantityControl);
  qsa("[data-variant-select]").forEach(setupVariantSelect);

  const setupShopCatalogFilterSurface = () => {
    if (!document.body.classList.contains("template-page-shop")) return;
    if (document.querySelector("[data-pma-shop-catalog-deeplink]")) return;
    if (document.querySelector("[data-section-handle='pma__commerce__collection_toolbar']")) return;

    let data = {
      catalogUrl: "/collections/all",
      copy: "Use filters on the All Products page to narrow by producer, category, storage, and more.",
      cta: "Open All Products filters",
      producerLabel: "Producer",
      producers: [],
    };
    const bootstrap = document.getElementById("PmaShopCatalogFilterBootstrap");
    if (bootstrap?.textContent) {
      try {
        const parsed = JSON.parse(bootstrap.textContent.trim());
        if (parsed && typeof parsed === "object") data = { ...data, ...parsed };
      } catch { /* use defaults */ }
    }

    const mount =
      document.querySelector("[data-hub-module-section] .pma-shop-hub__routing") ||
      document.querySelector("[data-section-handle='pma__commerce__guided_finder'] .pma-container") ||
      document.querySelector("#shop-products")?.closest(".pma-container") ||
      document.querySelector("[data-section-handle='pma__commerce__product_grid'] .pma-container");
    if (!mount) return;

    const wrap = document.createElement("div");
    wrap.className = "pma-shop-catalog-filters pma-mb-4";
    wrap.setAttribute("data-pma-shop-catalog-deeplink", "true");
    wrap.setAttribute("data-pma-shop-filter-surface", "commerce-js");

    const fallback = document.createElement("div");
    fallback.className = "pma-filter-panel__fallback";
    fallback.setAttribute("data-pma-filter-fallback", "");

    const copy = document.createElement("p");
    copy.className = "pma-filter-panel__fallback-copy";
    copy.textContent = data.copy || data.cta;
    fallback.appendChild(copy);

    const cta = document.createElement("a");
    cta.className = "pma-btn pma-btn--primary pma-filter-panel__fallback-catalog pma-filter-trigger";
    cta.href = data.catalogUrl || "/collections/all";
    cta.textContent = data.cta || "Browse the catalog with filters";
    fallback.appendChild(cta);

    if (Array.isArray(data.producers) && data.producers.length > 0) {
      const group = document.createElement("div");
      group.className = "pma-filter-group pma-mt-4";
      const label = document.createElement("div");
      label.className = "pma-filter-group__label";
      label.textContent = data.producerLabel || "Producer";
      group.appendChild(label);
      data.producers.forEach((producer) => {
        if (!producer?.url || !producer?.name) return;
        const link = document.createElement("a");
        link.className = "pma-filter-option pma-filter-option--link";
        link.href = producer.url;
        const span = document.createElement("span");
        span.textContent = producer.name;
        link.appendChild(span);
        group.appendChild(link);
      });
      fallback.appendChild(group);
    }

    wrap.appendChild(fallback);
    mount.insertAdjacentElement("afterend", wrap);
  };

  const runShopCatalogFilterSurface = () => setupShopCatalogFilterSurface();
  runShopCatalogFilterSurface();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runShopCatalogFilterSurface, { once: true });
  }

  // OPP-038: Cart form — highlight update button when quantities change;
  // submit tracking + post-update flash.
  const setupCartFormChangeDetection = () => {
    const form = document.querySelector("[data-pma-cart-form]");
    const updateBtn = form && form.querySelector("[data-pma-cart-update]");
    if (!form || !updateBtn) return;

    // Record initial quantities for dirty detection.
    const initialValues = new Map();
    qsa("[data-qty-input]", form).forEach((input) => {
      initialValues.set(input, input.value);
    });

    const checkDirty = () => {
      let dirty = false;
      initialValues.forEach((orig, input) => {
        if (input.value !== orig) dirty = true;
      });
      updateBtn.classList.toggle("pma-cart-items__update--dirty", dirty);
    };

    form.addEventListener("change", (e) => {
      if (e.target.matches("[data-qty-input]")) checkDirty();
    });

    form.addEventListener("input", (e) => {
      if (e.target.matches("[data-qty-input]")) checkDirty();
    });

    // Track form submission and set flash flag.
    form.addEventListener("submit", () => {
      try { sessionStorage.setItem("pma_cart_updated", "1"); } catch { /* Safari private mode or quota */ }
      try {
        if (window.PMA?.analytics?.track) {
          window.PMA.analytics.track("pma_cart_update", { item_count: initialValues.size });
        }
      } catch {}
    });
  };

  setupCartFormChangeDetection();

  // OPP-038: Cart post-update flash notification.
  const showCartFlash = () => {
    try {
      if (sessionStorage.getItem("pma_cart_updated") !== "1") return;
      sessionStorage.removeItem("pma_cart_updated");
    } catch { return; }
    const section = document.querySelector("[data-section-handle='pma__commerce__cart_items']");
    if (!section) return;
    const header = section.querySelector(".pma-cart-items__header");
    if (!header) return;
    const flash = document.createElement("div");
    flash.className = "pma-cart-flash";
    flash.setAttribute("role", "status");
    flash.textContent = "Cart updated.";
    header.after(flash);
    // Micro-delay lets the browser paint the element before the transition class triggers the fade-in.
    setTimeout(() => { flash.classList.add("pma-cart-flash--visible"); }, 20);
    setTimeout(() => {
      flash.classList.remove("pma-cart-flash--visible");
      setTimeout(() => { flash.remove(); }, 300);
    }, 3000);
  };

  showCartFlash();

  // OPP-038: Track cart item remove clicks.
  document.addEventListener("click", (e) => {
    const removeLink = e.target.closest("a[data-pma-cta='cart_remove']");
    if (!removeLink) return;
    try {
      if (window.PMA?.analytics?.track) {
        const item = removeLink.closest(".pma-cart-item");
        const title = item ? (item.querySelector(".pma-cart-item__title")?.textContent?.trim() || "") : "";
        window.PMA.analytics.track("pma_cart_remove", {
          product_title: title.slice(0, 100),
        });
      }
    } catch {}
  }, true);

  // Product page: mobile sticky add-to-cart bar visibility (page_specs §5.3).
  // Rendered only for active members via Liquid; JS toggles visibility after scroll past buybox.
  const setupStickyAtcBars = () => {
    const bars = qsa("[data-product-sticky-atc]");
    if (!bars.length) return;

    const mq = typeof window.matchMedia === "function" ? window.matchMedia("(max-width: 767px)") : null;
    const observers = new Map();

    function teardown(bar) {
      const obs = observers.get(bar);
      if (obs) {
        try { obs.disconnect(); } catch {}
        observers.delete(bar);
      }
    }

    function mount(bar) {
      teardown(bar);

      // If not mobile, keep hidden.
      if (mq && !mq.matches) {
        bar.setAttribute("aria-hidden", "true");
        return;
      }

      const scope = bar.closest("section") || document;
      const buybox = scope.querySelector(".pma-buybox");
      if (!buybox) {
        // Fallback: show on mobile if we can't find the buybox to observe.
        bar.setAttribute("aria-hidden", "false");
        return;
      }

      bar.setAttribute("aria-hidden", "true");

      const obs = new IntersectionObserver(
        (entries) => {
          const inView = !!(entries && entries[0] && entries[0].isIntersecting);
          bar.setAttribute("aria-hidden", inView ? "true" : "false");
        },
        { root: null, threshold: 0.15 }
      );
      obs.observe(buybox);
      observers.set(bar, obs);
    }

    bars.forEach(mount);

    if (mq) {
      // Re-mount on viewport changes.
      const onChange = () => bars.forEach(mount);
      try {
        mq.addEventListener("change", onChange);
      } catch {
        // Safari fallback
        mq.addListener(onChange);
      }
    }
  };

  setupStickyAtcBars();

  // Lock-state analytics (docs/gating/lock_state_system_spec.md §7). No PII.
  const body = document.body;
  const templateClass = body ? Array.from(body.classList).find((c) => c.startsWith("template-")) : "";
  const template = templateClass || "template-unknown";
  const memberState = body?.getAttribute("data-pma-member-state") || "locked";
  const canonicalMemberState = (() => {
    try {
      if (!body) return "unknown";
      return body.classList.contains("is-member-active") ? "member" : "non_member";
    } catch {
      return "unknown";
    }
  })();
  const shouldEmitLockAnalytics = canonicalMemberState !== "member";

  function getAnalyticsContext() {
    try {
      return typeof window.PMA_Analytics_Context === "object" ? window.PMA_Analytics_Context : {};
    } catch {
      return {};
    }
  }

  const lockPayload = (el) => {
    const surface = el.getAttribute("data-pma-lock-surface") || "other";
    const joinUrlPresent = el.getAttribute("data-pma-lock-join-url-present") === "true";
    return { surface, template, member_state: canonicalMemberState, membership_state: memberState, join_url_present: joinUrlPresent };
  };

  if (shouldEmitLockAnalytics) {
    qsa("[data-pma-lock-surface]").forEach((el) => {
      const payload = lockPayload(el);
      try {
        document.dispatchEvent(
          new CustomEvent("pma_lock_impression", { detail: payload, bubbles: true })
        );
        if (typeof window.dataLayer !== "undefined" && Array.isArray(window.dataLayer)) {
          window.dataLayer.push({ event: "pma_lock_impression", ...payload });
        }
        if (window.PMA?.analytics?.track) {
          const ctx = getAnalyticsContext();
          window.PMA.analytics.track("pma_lock_impression", {
            surface: payload.surface,
            reason: "membership_required",
          });
          const f10Payload = {
            lock_surface: payload.surface,
            resource_type: ctx.page_type || "page",
            lock_reason: "membership_required",
          };
          if (ctx.resource_type === "product" && ctx.resource_handle) f10Payload.product_handle = ctx.resource_handle;
          else if (ctx.resource_type === "collection" && ctx.resource_handle) f10Payload.collection_handle = ctx.resource_handle;
          window.PMA.analytics.track("pma_lock_price_view", f10Payload);
        }
        if (window.PMA?.analytics?.track && el.querySelector('[data-pma-cta="join"]')) {
          window.PMA.analytics.track("pma_lock_cta_view", {
            cta_id: "join_" + (payload.surface || "other"),
            lock_surface: payload.surface || "other",
          });
        }
      } catch {}
    });
  }

  const handleLockCtaClick = (event, eventName) => {
    const link = event.target.closest("a[href]");
    if (!link) return;
    const panel = link.closest("[data-pma-lock-surface]");
    const payload = panel
      ? lockPayload(panel)
      : { surface: "other", template, member_state: canonicalMemberState, membership_state: memberState, join_url_present: false };
    try {
      document.dispatchEvent(new CustomEvent(eventName, { detail: payload, bubbles: true }));
      if (typeof window.dataLayer !== "undefined" && Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: eventName, ...payload });
      }
      if (eventName === "pma_join_click" && window.PMA?.analytics?.track) {
        const ctx = getAnalyticsContext();
        const ctaId = link.getAttribute("data-pma-cta-id") || "join_" + (payload.surface || "other");
        window.PMA.analytics.track("pma_lock_cta_click", {
          surface: payload.surface || "other",
          cta: ctaId,
        });
        window.PMA.analytics.track("pma_join_cta_click", {
          cta_id: ctaId,
          cta_surface: payload.surface || "other",
          origin_page_type: ctx.page_type || "page",
          origin_resource_handle: ctx.resource_handle || undefined,
          destination: link.getAttribute("data-pma-cta") === "join" ? "join_url" : "url",
        });
      }
    } catch {}
  };

  document.addEventListener("click", (event) => {
    const joinLink = event.target.closest("a[data-pma-cta='join']");
    const loginLink = event.target.closest("a[data-pma-cta='login']");
    if (shouldEmitLockAnalytics) {
      if (joinLink) handleLockCtaClick(event, "pma_join_click");
      if (loginLink) handleLockCtaClick(event, "pma_login_click");
    }

    const filterRemoved = event.target.closest("[data-pma-cta='filter_removed']");
    const filtersCleared = event.target.closest("[data-pma-cta='filters_cleared']");
    if (filterRemoved) {
      try {
        if (window.PMA?.analytics?.track) {
          const handle = (window.location.pathname.split("/").filter(Boolean).pop()) || "";
          window.PMA.analytics.track("pma_filter_clear", {
            collection_handle: handle,
            filter_action: "remove_one",
          });
        }
      } catch {}
    }
    if (filtersCleared) {
      try {
        if (window.PMA?.analytics?.track) {
          const handle = (window.location.pathname.split("/").filter(Boolean).pop()) || "";
          window.PMA.analytics.track("pma_filter_clear", {
            collection_handle: handle,
            filter_action: "clear_all",
          });
        }
      } catch {}
    }
  }, true);

  function collectionHandleFromForm(form) {
    const action = form.getAttribute("action") || "";
    const path = action.split("?")[0] || "";
    const parts = path.split("/").filter(Boolean);
    return parts[parts.length - 1] === "collections" ? "" : (parts[parts.length - 1] || "");
  }

  document.addEventListener("submit", (event) => {
    const form = event.target.closest("form[data-pma-filters-form]");
    if (form) {
      form.querySelectorAll('input[type="number"], input[type="text"]').forEach((input) => {
        if (!input.name) return;
        if (String(input.value || "").trim() === "") {
          input.removeAttribute("name");
        }
      });
      const sortInput = form.querySelector('input[name="sort_by"]');
      if (sortInput && String(sortInput.value || "").trim() === "") {
        sortInput.removeAttribute("name");
      }
      try {
        if (window.PMA?.analytics?.track) {
          const handle = collectionHandleFromForm(form) || (window.location.pathname.split("/").pop() || "");
          const fd = new FormData(form);
          fd.forEach((value, key) => {
            if (key === "sort_by") return;
            window.PMA.analytics.track("pma_filter_apply", {
              collection_handle: handle,
              filter_group: key,
              filter_value: String(value).slice(0, 100),
              filter_action: "apply",
            });
          });
        }
      } catch {}
    }
  }, true);

  qsa(".pma-pagination a[href]").forEach((link) => {
    link.addEventListener("click", () => {
      try {
        if (window.PMA?.analytics?.track) {
          const href = link.getAttribute("href") || "";
          const pageNum = (() => {
            try {
              const u = new URL(href, window.location.origin);
              const p = u.searchParams.get("page");
              return p ? parseInt(p, 10) : 1;
            } catch { return 1; }
          })();
          const isPrev = link.classList.contains("pma-page--prev") || link.getAttribute("aria-label")?.toLowerCase().includes("previous");
          const isNext = link.classList.contains("pma-page--next") || link.getAttribute("aria-label")?.toLowerCase().includes("next");
          const action = isPrev ? "prev" : isNext ? "next" : "page";
          window.PMA.analytics.track("pma_pagination", {
            pagination_mode: "numbered",
            page_number: pageNum,
            action,
          });
        }
      } catch {}
    });
  });

  // F03.1 Collection sort: preserve filter params, set sort_by, remove page (R-F03.1-201–202).
  qsa("select[data-pma-collection-sort]").forEach((select) => {
    const form = select.closest("form");
    if (!form || form.method?.toLowerCase() !== "get") return;
    select.addEventListener("change", () => {
      const sortKey = select.value;
      const sortLabel = select.options[select.selectedIndex]?.text?.trim() || sortKey;
      const action = form.getAttribute("action") || "";
      const params = new URLSearchParams(new FormData(form));
      params.set("sort_by", sortKey);
      params.delete("page");
      const current = new URL(window.location.href);
      const canonicalCatalogSearch =
        String(current.pathname || "").replace(/\/+$/, "") === "/collections/all" &&
        String(current.searchParams.get("q") || "").trim() !== "";
      let url = "";
      if (canonicalCatalogSearch) {
        current.searchParams.set("sort_by", sortKey);
        current.searchParams.delete("page");
        current.hash = "#shop-products";
        url = current.pathname + current.search + current.hash;
      } else {
        const target = new URL(action || window.location.pathname, window.location.origin);
        target.search = params.toString();
        url = target.pathname + target.search + target.hash;
      }
      try {
        if (window.PMA?.analytics?.track) {
          const handle = collectionHandleFromForm(form) || (window.location.pathname.split("/").pop() || "");
          window.PMA.analytics.track("pma_sort_change", {
            sort_key: sortKey,
            sort_label: sortLabel.slice(0, 100),
            collection_handle: handle,
          });
        }
      } catch {}
      const catalogRouter = window.PMA?.catalogSearch?.navigate;
      if (canonicalCatalogSearch && typeof catalogRouter === "function") {
        catalogRouter(url, { historyMode: "push", scroll: true });
        return;
      }
      window.location.assign(url);
    });
  });

  // F03.3-T03 Search sort: submit form on change to preserve q and type.
  qsa("form[data-pma-search-sort] select[name='sort_by']").forEach((select) => {
    const form = select.closest("form");
    if (!form || form.method?.toLowerCase() !== "get") return;
    select.addEventListener("change", () => {
      if (window.PMA?.analytics?.track) {
        const sortKey = select.value;
        const query = (form.querySelector('input[name="q"]')?.value || "").trim().slice(0, 200);
        window.PMA.analytics.track("pma_sort_change", {
          sort_key: sortKey,
          search_ui: "page",
          query_length: query.length,
        });
      }
      form.submit();
    });
  });

  // F03.3-T11 Search form submit and filter/sort analytics.
  qsa('form[action*="/search"]').forEach((form) => {
    form.addEventListener("submit", () => {
      if (window.PMA?.analytics?.track) {
        const q = form.querySelector('input[name="q"]');
        const type = form.querySelector('input[name="type"]');
        const query = (q?.value ?? "").trim().slice(0, 200);
        const queryLength = query.length;
        if (form.hasAttribute("data-pma-search-filters")) {
          window.PMA.analytics.track("pma_filter_apply", {
            search_ui: "page",
            query_length: queryLength,
            type: type?.value ?? "product",
          });
        }
        window.PMA.analytics.track("pma_search_submit", {
          query_length: queryLength,
          search_ui: "page",
        });
      }
    });
  });

  document.body.addEventListener("click", (e) => {
    if (!window.PMA?.analytics?.track) return;
    const searchSection = document.querySelector(".pma-section--search-results");
    if (!searchSection?.contains(e.target)) return;
    const chipRemove = e.target.closest(".pma-applied-filters__chip-remove");
    const clearAll = e.target.closest(".pma-applied-filters__clear-link");
    if (chipRemove) window.PMA.analytics.track("pma_filter_clear", { filter_action: "remove_one", search_ui: "page" });
    if (clearAll) window.PMA.analytics.track("pma_filter_clear", { filter_action: "clear_all", search_ui: "page" });
  });

  function initFilterAccordions(root = document) {
    const mqDesktop = window.matchMedia("(min-width: 1024px)");
    qsa("[data-pma-filters-form]", root).forEach((form) => {
      const limitAttr = Number(form.getAttribute("data-pma-filter-value-limit") || "8");
      const baseLimit = Number.isFinite(limitAttr) && limitAttr > 0 ? limitAttr : 8;
      const inDrawer = Boolean(form.closest("#PmaFiltersDrawer, .pma-filters-drawer"));
      const inTopbar = Boolean(form.closest(".pma-filter-panel--topbar"));
      const valueLimit = inDrawer ? Math.min(baseLimit, 6) : baseLimit;
      const groups = qsa("[data-pma-filter-accordion]", form);

      groups.forEach((details) => {
        const summary = details.querySelector("summary");
        if (!summary) return;

        const syncExpanded = () => {
          summary.setAttribute("aria-expanded", details.open ? "true" : "false");
        };

        syncExpanded();

        if (details.dataset.pmaFilterAccordionBound !== "1") {
          details.dataset.pmaFilterAccordionBound = "1";

          details.addEventListener("toggle", () => {
            syncExpanded();

            if (inTopbar && details.open) {
              groups.forEach((other) => {
                if (other !== details && other.open) {
                  other.open = false;
                }
              });
            }
          });
        }
      });

      if (mqDesktop.matches && !inTopbar) {
        const anyOpen = groups.some((details) => details.open);
        if (!anyOpen && groups[0]) groups[0].open = true;
      }

      qsa("[data-pma-filter-show-more]", form).forEach((btn) => {
        if (btn.dataset.pmaFilterShowMoreBound === "1") return;
        btn.dataset.pmaFilterShowMoreBound = "1";
        const group = btn.closest("[data-pma-filter-accordion]");
        const hidden = group ? qsa(".pma-filter-option--truncated", group) : [];
        const moreLabel = btn.getAttribute("data-pma-more-label") || "Show more";
        const lessLabel = btn.getAttribute("data-pma-less-label") || "Show fewer";
        const setExpanded = (expanded) => {
          btn.setAttribute("aria-expanded", expanded ? "true" : "false");
          btn.textContent = expanded ? lessLabel : moreLabel;
          if (group) group.classList.toggle("is-values-expanded", expanded);
          hidden.forEach((el) => {
            el.hidden = !expanded;
          });
        };
        if (!hidden.length) {
          btn.hidden = true;
          return;
        }
        setExpanded(false);
        btn.addEventListener("click", (event) => {
          event.preventDefault();
          const expanded = group?.classList.contains("is-values-expanded") !== true;
          setExpanded(expanded);
        });
      });

      qsa("[data-pma-filter-values]", form).forEach((wrap) => {
        const limit = Number(wrap.getAttribute("data-pma-value-limit") || valueLimit);
        qsa(".pma-filter-option", wrap).forEach((opt, idx) => {
          if (idx >= limit) {
            opt.classList.add("pma-filter-option--truncated");
            if (!wrap.closest(".is-values-expanded")) opt.hidden = true;
          }
        });
      });
    });
  }

  async function fetchCollectionSurfaceHtml(collectionUrl, queryParams = "") {
    const base = collectionUrl.split("?")[0];
    const params = new URLSearchParams(String(queryParams || "").replace(/^\?/, ""));
    const previewThemeId = new URLSearchParams(window.location.search).get("preview_theme_id");
    if (previewThemeId && !params.has("preview_theme_id")) {
      params.set("preview_theme_id", previewThemeId);
    }
    const query = params.toString();
    const url = query ? `${base}?${query}` : base;
    for (let attempt = 1; attempt <= 5; attempt += 1) {
      const res = await fetch(url, { credentials: "same-origin" });
      if (!res.ok) throw new Error(`collection_html_fetch_failed_${res.status}`);
      const html = await res.text();
      if (html.includes("data-section-handle=\"pma__commerce__filters_panel\"")) return html;
      if (attempt === 5) return html;
      await new Promise((resolve) => setTimeout(resolve, attempt * 700));
    }
    throw new Error("collection_html_fetch_empty");
  }

  function copySectionInnerFromHtml(htmlString, handle, targetHandle = handle) {
    const doc = new DOMParser().parseFromString(htmlString, "text/html");
    const source = doc.querySelector(`[data-section-handle="${handle}"]`);
    const target = document.querySelector(`[data-section-handle="${targetHandle}"]`);
    if (!source || !target) return false;
    target.innerHTML = source.innerHTML;
    return true;
  }

  function patchShopFilterFormActions(root = document) {
    if (!document.body.classList.contains("template-page-shop")) return;
    const shopAction = window.location.pathname;
    qsa("form[data-pma-filters-form]", root).forEach((form) => {
      form.setAttribute("action", shopAction);
    });
  }

  function setupOrderPlanInline(root = document) {
    qsa("form.pma-order-plan-form--inline", root).forEach((form) => {
      if (form.dataset.pmaOrderPlanInlineBound === "1") return;
      form.dataset.pmaOrderPlanInlineBound = "1";

      const button =
        form.querySelector("[data-pma-order-plan-button]");
      const status =
        form.querySelector("[data-pma-order-plan-status]");

      if (!button) return;

      const defaultLabel =
        button.textContent.trim() || "Save for Membership";

      const setStatus = (message, error = false) => {
        if (!status) return;

        status.textContent = message;
        status.hidden = false;
        status.setAttribute(
          "data-pma-order-plan-status-kind",
          error ? "error" : "success"
        );
      };

      const clearStatus = () => {
        if (!status) return;

        status.textContent = "";
        status.hidden = true;
        status.removeAttribute(
          "data-pma-order-plan-status-kind"
        );
      };

      form.addEventListener("submit", async (event) => {
        event.preventDefault();

        if (form.dataset.pmaOrderPlanBusy === "1") return;

        form.dataset.pmaOrderPlanBusy = "1";
        button.disabled = true;
        clearStatus();

        try {
          const rootPath =
            window.Shopify?.routes?.root || "/";

          const endpoint =
            rootPath.replace(/\/?$/, "/") + "cart/add.js";

          const payload = new FormData(form);
          payload.delete("return_to");

          const response = await fetch(endpoint, {
            method: "POST",
            body: payload,
            credentials: "same-origin",
            headers: {
              Accept: "application/json",
              "X-Requested-With": "XMLHttpRequest"
            }
          });

          if (!response.ok) {
            throw new Error(
              "order_plan_add_failed_" + response.status
            );
          }

          button.textContent = "Saved for Membership";
          setStatus("Saved for Membership.");

          document.dispatchEvent(
            new CustomEvent("pma:order-plan-added", {
              bubbles: true,
              detail: {
                productHandle:
                  form
                    .closest("[data-pma-product-card]")
                    ?.getAttribute("data-product-handle") || "",
                variantId:
                  form.querySelector('input[name="id"]')
                    ?.value || ""
              }
            })
          );

          window.setTimeout(() => {
            button.textContent = defaultLabel;
            button.disabled = false;
            form.dataset.pmaOrderPlanBusy = "0";
            clearStatus();
          }, 1800);
        } catch (err) {
          button.textContent = defaultLabel;
          button.disabled = false;
          form.dataset.pmaOrderPlanBusy = "0";

          setStatus(
            "Could not save this product for Membership. Try again.",
            true
          );

          reportInitError("order_plan_inline", err);
        }
      });
    });
  }

  function rebindCommerceUi(root = document) {
    qsa("[data-qty-control]", root).forEach(setupQuantityControl);
    qsa("[data-variant-select]", root).forEach(setupVariantSelect);
    setupOrderPlanInline(root);
    initFilterAccordions(root);
    patchShopFilterFormActions(root);
  }
  window.PMA = window.PMA || {};
  window.PMA.commerce = window.PMA.commerce || {};
  window.PMA.commerce.rebind = rebindCommerceUi;


  function shopCatalogCollectionUrl() {
    const filtersPanel = document.querySelector('[data-section-handle="pma__commerce__filters_panel"]');
    return (
      filtersPanel?.getAttribute("data-pma-shop-filter-collection-url")
      || document.querySelector('[data-section-handle="pma__commerce__product_grid"]')?.getAttribute("data-pma-shop-grid-collection-url")
      || "/collections/all"
    );
  }

  async function hydrateShopCatalogSurface(filterQuery = "", { includeGrid = false } = {}) {
    if (!document.body.classList.contains("template-page-shop")) {
      return { ok: false, reason: "not_shop_template" };
    }
    const collectionUrl = shopCatalogCollectionUrl();
    const collectionHtml = await fetchCollectionSurfaceHtml(collectionUrl, filterQuery);
    const filtersPanel = document.querySelector('[data-section-handle="pma__commerce__filters_panel"]');
    if (filtersPanel) {
      const merged = copySectionInnerFromHtml(collectionHtml, "pma__commerce__filters_panel");
      filtersPanel.setAttribute("data-pma-shop-filter-hydrate", merged ? "done" : "failed");
      if (!merged) return { ok: false, reason: "filters_hydrate_failed" };
    }
    if (includeGrid) {
      copySectionInnerFromHtml(collectionHtml, "pma__commerce__product_grid");
      copySectionInnerFromHtml(collectionHtml, "pma__commerce__collection_toolbar");
      document
        .querySelector('[data-section-handle="pma__commerce__product_grid"]')
        ?.setAttribute("data-pma-shop-grid-hydrate", "done");
    }
    rebindCommerceUi();
    return { ok: true };
  }

  function bindShopCatalogFilterSubmit() {
    if (!document.body.classList.contains("template-page-shop")) return;
    document.addEventListener(
      "submit",
      async (event) => {
        const form = event.target.closest("form[data-pma-filters-form]");
        if (!form || !document.body.contains(form)) return;
        if (form.getAttribute("data-pma-shop-filters-ssr") === "true") return;
        event.preventDefault();
        const params = new URLSearchParams(new FormData(form));
        form.querySelectorAll('input[type="number"], input[type="text"]').forEach((input) => {
          if (!input.name) return;
          if (String(input.value || "").trim() === "") params.delete(input.name);
        });
        const sortInput = form.querySelector('input[name="sort_by"]');
        if (sortInput && String(sortInput.value || "").trim() === "") params.delete("sort_by");
        const query = params.toString();
        const shopPath = `${window.location.pathname}${query ? `?${query}` : ""}#shop-products`;
        window.history.pushState({ pmaShopFilters: true }, "", shopPath);
        try {
          await hydrateShopCatalogSurface(query ? `?${query}` : "", { includeGrid: true });
          document.dispatchEvent(new CustomEvent("pma:shop-filters-applied", { bubbles: true }));
        } catch (err) {
          reportInitError("shop_filter_apply", err);
          const fallback = form.getAttribute("action") || shopCatalogCollectionUrl();
          window.location.assign(query ? `${fallback.split("?")[0]}?${query}` : fallback);
        }
      },
      true,
    );
  }

  async function initShopCatalogHydration() {
    if (!document.body.classList.contains("template-page-shop")) return;
    if (document.querySelector('[data-pma-shop-filters-ssr="true"]')) return;
    const hasFilterParams = window.location.search.includes("filter.");
    const needsFilters = document.querySelector('[data-pma-shop-filter-hydrate="pending"]');
    if (!needsFilters && !hasFilterParams) return;
    for (let attempt = 1; attempt <= 4; attempt += 1) {
      try {
        await hydrateShopCatalogSurface(window.location.search || "", { includeGrid: hasFilterParams });
        const forms = document.querySelectorAll("[data-pma-filters-form]").length;
        if (forms > 0 || document.querySelector('[data-pma-shop-filter-hydrate="done"]')) return;
        if (!needsFilters) return;
      } catch (err) {
        reportInitError("shop_filter_hydrate", err);
      }
      await new Promise((resolve) => setTimeout(resolve, attempt * 1000));
    }
  }

  setupOrderPlanInline();
  bindShopCatalogFilterSubmit();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initShopCatalogHydration(), { once: true });
  } else {
    initShopCatalogHydration();
  }
  window.addEventListener("popstate", () => {
    if (!document.body.classList.contains("template-page-shop")) return;
    if (document.querySelector('[data-pma-shop-filters-ssr="true"]')) return;
    initShopCatalogHydration();
  });

  initFilterAccordions();
  } catch (err) {
    reportInitError("init", err);
  }
})();
